import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { lazy, Suspense, useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./CartContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import PopupModal from "./components/PopupModal";

// Code-split all pages — only load the page the user visits
const HomePage = lazy(() => import("./pages/HomePage"));
const MenuPage = lazy(() => import("./pages/MenuPage"));
const ReservationsPage = lazy(() => import("./pages/ReservationsPage"));
const EventsPage = lazy(() => import("./pages/EventsPage"));
const CateringPage = lazy(() => import("./pages/CateringPage"));
const FranchisePage = lazy(() => import("./pages/FranchisePage"));
const AdminPage = lazy(() => import("./pages/AdminPage"));
const StaffPage = lazy(() => import("./pages/StaffPage"));

function PageLoader() {
  return (
    <div className="min-h-screen bg-[#0B0B0F] flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-[#C9A227]/30 border-t-[#C9A227] rounded-full animate-spin" />
    </div>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppLayout() {
  const location = useLocation();
  const isAdmin = location.pathname === "/admin";
  const isStaff = location.pathname === "/staff";

  if (isAdmin) {
    return (
      <Suspense fallback={<PageLoader />}>
        <AdminPage />
      </Suspense>
    );
  }

  if (isStaff) {
    return (
      <Suspense fallback={<PageLoader />}>
        <StaffPage />
      </Suspense>
    );
  }

  return (
    <>
      <Navbar />
      <PopupModal />
      <main>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/reservations" element={<ReservationsPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/catering" element={<CateringPage />} />
            <Route path="/franchise" element={<FranchisePage />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <CartProvider>
      <Router>
        <ScrollToTop />
        <AppLayout />
        <Toaster position="top-center" richColors />
      </Router>
    </CartProvider>
  );
}
